import React from "react";
import SearchBar from "./SearchBar";
import { Link } from "react-router-dom";
import { IoMdFootball } from "react-icons/io";

function FindPitch() {
  return (
    <section className="flex flex-col items-center absolute top-3/5 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 sm:w-150 md:w-170 gap-8 text-center mt-8">
      {/* SEO-Optimized Heading */}
      <header>
        <h1 className="text-white text-3xl sm:text-5xl md:text-7xl font-extrabold drop-shadow-lg">
          <span className="block">
            Halısaha Kiralama Deneyimini Bir Üst Seviyeye Taşı
          </span>
        </h1>
        <p className="text-white text-base sm:text-lg md:text-xl mt-2 opacity-90 font-medium">
          Saha kirala, takım arkadaşı bul veya rakip bul - hepsi bir arada!
        </p>
      </header>

      {/* Search Component */}
      <SearchBar />

      {/* CTA Buttons */}
      <div className="flex flex-col sm:flex-row gap-4">
        <Link to="/sahalar" className="w-full sm:w-auto">
          <button
            className="w-full bg-[#4d9041] text-white px-8 py-4 rounded-xl font-semibold shadow-lg hover:bg-[#62a556] transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer flex items-center justify-center gap-2"
            aria-label="Halısaha ara"
          >
            <IoMdFootball className="text-xl" />
            <span>Saha Kirala</span>
          </button>
        </Link>
        <Link to="/takim-arkadasi-bul" className="w-full sm:w-auto">
          <button
            className="w-full bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-xl font-semibold shadow-lg hover:bg-white/20 transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer border border-white/20"
            aria-label="Takım arkadaşı bul"
          >
            Takım Arkadaşı Bul
          </button>
        </Link>
        <Link to="/rakip-bul" className="w-full sm:w-auto">
          <button
            className="w-full bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-xl font-semibold shadow-lg hover:bg-white/20 transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer border border-white/20"
            aria-label="Rakip bul"
          >
            Rakip Bul
          </button>
        </Link>
      </div>

      {/* SEO-Optimized Supporting Text */}
      <p className="text-white text-sm sm:text-base opacity-80 max-w-lg">
        Saha kiralama, oyuncu bulma ve maç ayarlama artık çok kolay. Futbol
        keyfini kesintisiz yaşa!
      </p>
      <div className="flex items-center justify-center gap-4 text-white/80 text-sm sm:text-base">
        <div className="flex items-center gap-2">
          <span className="w-2 h-2 bg-[#4d9041] rounded-full"></span>
          <span>7/24 Rezervasyon</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="w-2 h-2 bg-[#4d9041] rounded-full"></span>
          <span>Güvenli Ödeme</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="w-2 h-2 bg-[#4d9041] rounded-full"></span>
          <span>Anında Onay</span>
        </div>
      </div>
    </section>
  );
}

export default FindPitch;
